import { useCallback, useEffect, useRef, useState } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { Translate } from '@innovatrics/checkin-components'
import '@innovatrics/dot-document-auto-capture'
import '@innovatrics/dot-auto-capture-ui/document'
import type { DocumentUiProps } from '@innovatrics/dot-auto-capture-ui/document'
import type {
  DocumentCameraProps,
  DocumentCallback,
} from '@innovatrics/dot-document-auto-capture'

import {
  dispatchControlEvent,
  DocumentCustomEvent,
  ControlEventInstruction,
} from '@innovatrics/dot-document-auto-capture/events'

interface AutoCaptureProps {
  handlePhotoTaken: DocumentCallback
}

const DocumentCamera = (props: DocumentCameraProps) => {
  const xDotDocumentAutoCapture = useRef(null)
  useEffect(() => {
    if (xDotDocumentAutoCapture.current) {
      xDotDocumentAutoCapture.current.cameraOptions = props
    }
  })
  return (
    <x-dot-document-auto-capture
      // @ts-ignore
      ref={xDotDocumentAutoCapture}
      id="x-dot-document-auto-capture"
    />
  )
}

const DocumentUi = (props: DocumentUiProps) => {
  const xDotDocumentAutoCaptureUi = useRef(null)
  useEffect(() => {
    if (xDotDocumentAutoCaptureUi.current) {
      xDotDocumentAutoCaptureUi.current.props = props
    }
  })
  return (
    <x-dot-document-auto-capture-ui
      // @ts-ignore
      ref={xDotDocumentAutoCaptureUi}
      id="x-dot-document-auto-capture-ui"
    />
  )
}

export const AutoCapture = ({ handlePhotoTaken }: AutoCaptureProps) => {
  // const [height, setHeight] = useState('130vh')

  // useEffect(() => {
  //   const setElHeight = (mutationsList) => {
  //     for (const mutation of mutationsList) {
  //       if (mutation.type === 'attributes') {
  //         let h = document.getElementsByTagName('video')?.[0]?.clientWidth
  //         let w = document.getElementById('container')?.clientWidth
  //         if (w != h && h != 0) setHeight('inherit')

  //         if (
  //           document.getElementsByTagName('x-dot-document-auto-capture')?.[0]
  //             ?.firstChild?.firstChild
  //         ) {
  //           document.getElementsByTagName(
  //             'x-dot-document-auto-capture'
  //             // @ts-ignore
  //           )[0].firstChild.firstChild.style.alignItems = 'start'
  //         }
  //       }
  //     }
  //   }

  //   const handleOrientation = () => {
  //     setHeight('130vh')
  //   }

  //   window.addEventListener('deviceorientation', handleOrientation, true)
  //   const observer = new MutationObserver(setElHeight)
  //   observer.observe(document, {
  //     attributes: true,
  //     childList: true,
  //     subtree: true,
  //   })
  //   document.addEventListener('onresize', setElHeight)
  // }, [])

  useEffect(() => {
    detectionEvenet()
  })
  const detectionEvenet = useCallback(() => {
    dispatchControlEvent(
      DocumentCustomEvent.CONTROL,
      ControlEventInstruction.CONTINUE_DETECTION
    )
  }, [])

  return (
    <Box sx={{ background: '#F2F3F4', minHeight: 'inherit' }}>
      <Typography
        fontSize={'20px'}
        fontWeight={600}
        textAlign={'center'}
        paddingTop={'8px'}
        marginBottom={'30px'}
        color={'secondary'}
      >
        <Translate
          entityName={'customer.capture.title'}
          defaultMessage={'Place your document in the rectangle'}
        />
      </Typography>

      <Grid
        container
        id="container"
        justifySelf={'center'}
        maxWidth={'1200px'}
        margin={'0 auto'}
        // minHeight={height}
      >
        <div
          style={{
            width: '100%',
            position: 'relative',
          }}
        >
          <DocumentCamera
            imageType="jpeg"
            cameraFacing="environment"
            onPhotoTaken={handlePhotoTaken}
            onError={(e) => console.error('ERROR ', e)}
            samWasmUrl={'/sam.wasm'}
          />
          <DocumentUi
            appStateInstructions={{
              waiting: {
                text: 'Processing...',
                visible: true,
              },
            }}
            showDetectionLayer
            showCameraButtons
          />
        </div>
      </Grid>
    </Box>
  )
}
